(() => {
  if (customElements.get('videos-feed')) {
    return;
  }

  class VideosFeed extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.swiper')) return;

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        breakpoints: {
          990: {
            spaceBetween: 32,
            slidesPerView: 4,
          },
        },
      };
      this.slider = new Swiper(this.querySelector('.swiper'), this.options);
    }
  }

  customElements.define('videos-feed', VideosFeed);
})();
